module.exports = __webpack_public_path__ + "static/media/linkedin-logo-icon.95ff99a1.png";